// extracted by mini-css-extract-plugin
export default {"greetings":"ReceivingArea_greetings__sKpJH"};